import { Pipe, PipeTransform } from '@angular/core';
import { AccountAttributesEnum } from '../../enums';
import { UserService } from '../../../core/services/user.service';

@Pipe({
    name: 'hasAccess',
    standalone: false
})
export class HasAccessPipe implements PipeTransform {
    constructor(private readonly userService: UserService) {
    }
    transform(attributes: AccountAttributesEnum | AccountAttributesEnum[], every?: boolean): boolean {
        return this.userService.hasAccess(attributes);
    }
}
